import React, { Component, createRef } from 'react';
import PropTypes from 'prop-types';
import ReactGA from 'react-ga';
import { connect } from 'react-redux';
import { isEmpty } from 'lodash';
import { NotificationPanel } from '@components';
import { Loader } from '@components/common';
import { ConfirmationModal } from '@components/modals';
import { thunks } from '@redux/app';

class NotificationSettings extends Component {
	constructor(props) {
		super(props);
		this.smsOptInModal = createRef();
	}

	componentDidMount = () => {
		const { user } = this.props;
		if (!isEmpty(user)) this.getNotificationSettings();
	}

	UNSAFE_componentWillReceiveProps = ({ user }) => {
		const lastProps = this.props;
		if (!isEmpty(user) && isEmpty(lastProps.user)) this.getNotificationSettings();
	}

	getNotificationSettings = () => {
		const { dispatch } = this.props;

		dispatch(thunks.getNotificationSettings());
	}

	onSwitchToggle = (property, type) => {
		const { dispatch, settings } = this.props;
		const isOptedIn = settings.some(({ NotificationMethods }) => NotificationMethods.some((m) => m.Enabled && m.MethodType === 2));
		// property is index in the array of methods
		const method = settings[property].NotificationMethods.find((m) => m.MethodName === type);
		if (type === 'SMS' && !method.Enabled && !isOptedIn) {
			this.smsOptInModal.openModal({
				title              : 'Enable SMS',
				subTitle           : 'By enabling this toggle, you consent to receive SMS messages (including text messages) from RollKall, notwithstanding any current or prior election to opt in or opt out of receiving SMS messages, at the specific number(s) you have provided to us, or numbers we can reasonably associate with your account, with information or questions related to your account.',
				confirmationButton : 'I agree',
				onConfirm          : () => {
					dispatch(thunks.updateNotifactionSettings(property, type));
					ReactGA.event({
						category : 'Notifications',
						action   : 'Changed Notification Setting.',
						label    : `${type} [On/Off]`,
					});
				},
			});
		} else {
			dispatch(thunks.updateNotifactionSettings(property, type));
			ReactGA.event({
				category : 'Notifications',
				action   : 'Changed Notification Setting.',
				label    : `${type} [On/Off]`,
			});
		}
	}

	render() {
		const {
			settings,
			loading,
			setRef,
		} = this.props;

		return (
			<div
				className="card-section"
				ref={(ref) => setRef(ref)}
			>
				<h5 className="color-dark font-bold margin-bottom-20">Notification Settings</h5>
				<NotificationPanel
					hideTitle
					settings={settings}
					onSwitchToggle={this.onSwitchToggle}
				/>
				<Loader active={loading} />
				<ConfirmationModal ref={(ref) => { this.smsOptInModal = ref; }} />
			</div>
		);
	}
}

const mapStateToProps = ({
	app : {
		user,
		notification : {
			settings,
			loading,
		},
	},
}) => ({
	settings,
	user,
	loading,
});

const mapDispatchToProps = (dispatch) => ({
	dispatch,
});

NotificationSettings.propTypes = {
	dispatch : PropTypes.func.isRequired,
	loading  : PropTypes.bool,
	setRef   : PropTypes.func.isRequired,
	settings : PropTypes.array,
	user     : PropTypes.object,
};

NotificationSettings.defaultProps = {
	loading  : false,
	settings : [],
	user     : {},
};

export default connect(mapStateToProps, mapDispatchToProps)(NotificationSettings);
